/* Store layout helpers: hero slider and product/review carousels. */
(function () {
  if (!customElements.get('rc-slider')) {
    class RcSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.count = this.querySelector('[data-count]');
        this.index = 0;
        if (!this.track || this.slides.length < 2) return;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.track.addEventListener('scroll', () => {
          window.clearTimeout(this.t);
          this.t = window.setTimeout(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (i !== this.index) { this.index = i; this.update(); }
          }, 80);
        }, { passive: true });
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.reduce = reduce;
        if (this.dataset.autoplay === 'true' && !window.Shopify?.designMode) {
          this.start = () => { window.clearInterval(this.timer); this.timer = window.setInterval(() => this.go(this.index + 1), Number(this.dataset.speed) || 6000); this.update(); };
          this.start();
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
        }
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.findIndex((s) => s.contains(e.target));
          if (i > -1) { this.stop(); this.go(i); }
        });
      }
      stop() { window.clearInterval(this.timer); this.timer = null; this.querySelector('.rc-hero__progress')?.classList.remove('is-running'); }
      go(i, user) {
        if (user) { this.stop(); if (this.start) window.setTimeout(() => { if (!this.matches(':hover')) this.start(); }, 50); }
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: this.reduce ? 'auto' : 'smooth' });
        this.update();
      }
      update() {
        const ring = this.querySelector('.rc-hero__progress');
        if (ring) { ring.classList.remove('is-running'); void ring.offsetWidth; if (this.timer) ring.classList.add('is-running'); }
        if (this.count) this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
        this.slides.forEach((s, k) => s.setAttribute('aria-hidden', k === this.index ? 'false' : 'true'));
      }
    }
    customElements.define('rc-slider', RcSlider);
  }

  if (!customElements.get('rc-carousel')) {
    class RcCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;
        const step = () => {
          const item = this.track.firstElementChild;
          if (!item) return this.track.clientWidth;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return item.getBoundingClientRect().width + gap;
        };
        this.prev?.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        this.next?.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
        const sync = () => {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max;
          const nav = this.querySelector('.rc-carousel__nav');
          if (nav) nav.hidden = max <= 0;
        };
        this.track.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();
        // Optional auto-rotate (data-autoplay="true", data-speed in ms) with a Pause/Play button
        if (this.dataset.autoplay === 'true' && !window.Shopify?.designMode) {
          const speed = Number(this.dataset.speed) || 5000;
          const btn = this.querySelector('[data-pause]');
          let paused = false, hover = false;
          const tick = () => {
            if (paused || hover || document.hidden) return;
            const max = this.track.scrollWidth - this.track.clientWidth - 2;
            if (this.track.scrollLeft >= max) this.track.scrollTo({ left: 0, behavior: 'smooth' });
            else this.track.scrollBy({ left: step(), behavior: 'smooth' });
          };
          let timer = window.setInterval(tick, speed);
          const setPaused = (v) => {
            paused = v;
            if (btn) {
              btn.setAttribute('aria-pressed', String(v));
              btn.querySelector('[data-pause-label]').textContent = v ? btn.dataset.play : btn.dataset.pauseText;
              btn.classList.toggle('is-paused', v);
            }
          };
          btn?.addEventListener('click', () => setPaused(!paused));
          this.addEventListener('mouseenter', () => (hover = true));
          this.addEventListener('mouseleave', () => (hover = false));
          this.addEventListener('focusin', () => (hover = true));
          this.addEventListener('focusout', () => (hover = false));
          [this.prev, this.next].forEach((b) => b?.addEventListener('click', () => { window.clearInterval(timer); timer = window.setInterval(tick, speed); }));
        }
      }
    }
    customElements.define('rc-carousel', RcCarousel);
  }
})();
